// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1Gbuw","calendarButtons":"ClockData_calendarButtons__2wRGL"};